import type { UUID } from '@aline/common';
import type { ExistingContractType } from 'src/components/generic/ContractTypeAutocomplete';
import { v4 as uuid4 } from 'uuid';

const PENDING_CONTRACT_TYPE_ID_PREFIX = 'pending-contract-type:';

/**
 * A contract type the user just typed that the server has not created yet. It can
 * be shown on a document like any other type; updateDocumentType sends it by value
 * and the server finds or creates the real type in the same request.
 */
export function createPendingContractType(value: string): ExistingContractType {
  return {
    __typename: 'ContractType',
    id: `${PENDING_CONTRACT_TYPE_ID_PREFIX}${uuid4()}`,
    value: value.trim(),
  };
}

export function getIsPendingContractType(contractType: Pick<ExistingContractType, 'id'>): boolean {
  return contractType.id.startsWith(PENDING_CONTRACT_TYPE_ID_PREFIX);
}

export function getDocumentTypeInput(contractType: ExistingContractType | null): {
  contractTypeId: UUID | null;
  newContractTypeValue: string | null;
} {
  if (contractType && getIsPendingContractType(contractType))
    return { contractTypeId: null, newContractTypeValue: contractType.value };

  return { contractTypeId: contractType?.id ?? null, newContractTypeValue: null };
}
